import styled from 'styled-components'

export const Container = styled.div`
  position: relative;

  padding: 38px 20px 52px 20px;

  background-color: ${({ theme }) => (theme.isDark ? '#1B1B1B' : '#fff')};

  border-radius: 24px 24px 0 0;

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .close {
    border: none;
    background: none;

    width: 36px;
    height: 36px;

    position: absolute;

    top: 30px;
    right: 20px;

    svg {
      path {
        stroke: rgb(${({ theme }) => theme.excerpt.primary});
      }
    }
  }

  .title {
    color: rgb(${({ theme }) => theme.excerpt.primary});

    margin-bottom: 4px;

    font-size: 18px;
    font-weight: 700;
    line-height: 120%;

    margin-bottom: 30px;
  }

  .description {
    color: rgb(${({ theme }) => theme.excerpt.primary});

    font-size: 16px;
    font-weight: 600;
    line-height: 120%;

    margin-bottom: 24px;
  }

  .input-group {
    display: flex;
    flex-direction: column;
    gap: 24px;

    margin-bottom: 24px;

    .text-input {
      padding: 1rem;
      border-radius: 8px;

      background: transparent;

      width: 100%;

      font-size: 16px;

      color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
      font-weight: 600;

      border: ${({ theme }) => `1px solid rgb(${theme.component.accent})`};

      &::placeholder {
        font-weight: 400;
        color: ${({ theme }) => `rgb(${theme.grayscale.neutral})`};
      }
    }

    .save {
      color: ${({ theme }) => `rgb(${theme.background.low})`};

      background-color: rgb(${({ theme }) => theme.primary.base});
      border: none;

      border-radius: 4px;

      text-align: center;
      font-size: 16px;
      font-weight: 600;
      line-height: 140%;

      height: 52px;

      transition: opacity 0.3s ease;

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }

      &[data-loading='true'] {
        cursor: progress;
      }

      .loader {
        width: 32px;
        height: 32px;
      }
    }
  }

  .current-name {
    color: rgb(${({ theme }) => theme.excerpt.primary});

    font-size: 16px;
    font-weight: 600;
    line-height: 120%;
  }

  @media only screen and (min-width: 800px) {
    border-radius: 6px;

    padding: 30px 30px 40px 38px;

    min-width: 600px;
  }

  @media only screen and (min-width: 1000px) {
    min-width: 800px;

    margin: 0 auto;

    padding: 30px 54px 60px 45px;

    .close {
      right: 54px;
    }

    .title {
      font-size: 24px;

      margin-bottom: 40px;
    }

    .description {
      margin-bottom: 12px;
    }

    .input-group {
      flex-direction: row;
      gap: 24px;

      .save {
        flex: 1 0 222px;

        white-space: nowrap;
      }
    }

    .current-name {
      border-top: ${({ theme }) => `1px solid rgb(${theme.component.accent})`};
      padding-top: 18px;
    }
  }
`

export const WarningContainer = styled.div`
  display: flex;
  width: 100%;
  height: 103px;
  flex-shrink: 0;
  border-radius: 4px;
  margin-top: 30px;
  padding: 19.5px 10px 19.5px 22px;
  background: ${({ theme }) => `rgb(${theme.grayscale[400]})`};

  p {
    margin-left: 20px;
    display: flex;
    width: 350px;
    flex-direction: row;
  }

  @media only screen and (min-width: 800px) {
    width: 711px;
    height: 63px;
    padding: 19.5px 77px 19.5px 22px;

    p {
      flex-basis: content;
    }
  }
`
